<template>
  <div class="shareInNetwork">
     <div class="prdt_hdng">{{$t('shareAndEarnInNetwork')}}</div>
    <h5 class="head">{{$t('shareAndEarnfivePerson')}}</h5>
  </div>
</template>

<script>
export default {
  name: "ShareInNetwork",
  
  data() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>
    